import { IonModal } from "@ionic/react";
import { FC } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";



interface UserInfo {
  email?: string;
  phone_number?: string;
}

interface MilestoneInfo {
  id: number;
  startOffset: number; // Days after inclusion
  duration: number; // Days available
}

interface Props {
  isOpen: boolean;
  onDismiss(): void;
  inclusionDate: Date;
  milestone: MilestoneInfo;
  user: UserInfo;
  onAccessQuestionnaire(): void;
}

// Utility to add N days to a date
const addDays = (date: Date, days: number) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const isFakeEmail = (email: string) =>
  /^user_.*@etudementalo\.fr$/.test(email);

const isFakePhone = (phone: string) =>
  phone === "0607080910";

const MilestoneModal: FC<Props> = ({
  isOpen,
  onDismiss,
  inclusionDate,
  milestone,
  user,
  onAccessQuestionnaire
}) => {
  const today = new Date();

  const startDate = addDays(inclusionDate, milestone.startOffset);
  const endDate = addDays(startDate, milestone.duration);

  const diffToStart = Math.ceil((startDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  const diffToEnd = Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

  const isPastDeadline = diffToEnd < 0;
  const isAvailable = diffToStart <= 0 && !isPastDeadline;

  const showEmailReminder = user?.email && !isFakeEmail(user.email);
  const showSMSReminder = user?.phone_number && !isFakePhone(user.phone_number);

  let message: string;
  const { t } = useTranslation();

if (isPastDeadline) {
  message = t("milestone_passed");
} else if (isAvailable) {
  message = t("milestone_available");
} else {
  const plural = diffToStart !== 1 ? "s" : "";
  message = t("milestone_soon", { count: diffToStart, plural });


  const reminders: string[] = [];
  if (showEmailReminder) reminders.push("email");
  if (showSMSReminder) reminders.push("SMS");

  if (reminders.length > 0) {
    message += " " + t("milestone_reminder", {
      methods: reminders.join(" and "),
    });
  }
}

  return (
    <IonModal
      cssClass="resonance-modal"
      isOpen={isOpen}
      backdropDismiss={true}
      onWillDismiss={onDismiss}
    >
      <Container onClick={onDismiss}>
        <Card onClick={(e) => e.stopPropagation()}>
          <Title>{t("milestone")}</Title>
          <Message>{message}</Message>

          <Buttons>
            <ModalButton onClick={onDismiss}>Close</ModalButton>
            {/* {isAvailable && (
              <ModalButton2 onClick={onAccessQuestionnaire}>
                Go to Questionnaire
              </ModalButton2>
            )} */}
          </Buttons>
        </Card>
      </Container>
    </IonModal>
  );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Card = styled.div`
  width: 90%;
  max-width: 400px;
  background-color: #FFFFFF;
  border-radius: 25px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.div`
  font-size: 22px;
  text-align: center;
  margin-bottom: 10px;
  color: black;
`;

const Message = styled.div`
  font-size: 18px;
  padding: 10px 10px;
  text-align: left;
  color: black;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const ModalButton = styled.button`
  background-color: #eee;
  margin: 0px 10px;
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: black;
`;

const ModalButton2 = styled.button`
  background-color: #007aff;
  margin: 0px 10px;
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  color: white;
`;

export default MilestoneModal;
